export async function doAndSnack(promise, enqueueSnackbar, options) {
  const { success = 'Success', fail = 'Fail', onSuccess } = options
  try {
    const res = await promise
    enqueueSnackbar(success, {
      variant: 'success',
    })
    if (onSuccess) onSuccess(res)
  } catch (error) {
    enqueueSnackbar(error?.cause === 409 ? error.message : fail, {
      variant: 'error',
    })
  }
}

export function snackProgressBar(enqueueSnackbar, options, isSuccess) {
  const { success = 'Success', fail = 'Fail' } = options
  if (isSuccess) {
    enqueueSnackbar(success, {
      variant: 'success',
    })
  } else {
    enqueueSnackbar(fail, {
      variant: 'error',
    })
  }
}
